import { type RaumBlockung, type Veranstaltung } from '../../../dtos.js';
import { getLocationKuerzel, getLocationName, getStandortName } from '../../../utils';
import { getLocationArt } from '../../../utils/getBezeichnungen/getBezeichnungen.js';

export const getStandortLabel = (veranstaltung: Veranstaltung): string => getStandortName(veranstaltung) ?? '-';

export const getLocationKuerzelLabel = (veranstaltung: Veranstaltung): string =>
  getLocationKuerzel(veranstaltung) ?? '-';

export const getLocationLabel = (veranstaltung: Veranstaltung): string => getLocationName(veranstaltung) ?? '-';

export const getLocationArtLabel = (veranstaltung: Veranstaltung): string => {
  const locationArt = getLocationArt(veranstaltung);

  if (!locationArt) {
    return '-';
  }

  const label = {
    HOTEL: 'Hotel',
    PC_CENTER: 'PC-Center',
    VERANSTALTUNGSLOCATION: 'Veranstaltungslocation',
  };
  return label[locationArt];
};

export const getRaumartLabel = (raum: RaumBlockung['raum']) => (raum.isGruppenraum ? 'Gruppenraum' : 'Seminarraum');
